import React, { useState, useEffect } from 'react';
import { 
  Snackbar, 
  Alert, 
  Button, 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography 
} from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

const UpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    // Register service worker update listener
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'SW_UPDATED') {
          setShowUpdate(true);
          setShowDialog(true);
        }
      });

      // Check for updates every 5 minutes
      const checkForUpdates = () => {
        navigator.serviceWorker.ready.then((registration) => {
          registration.update();
        });
      };

      const interval = setInterval(checkForUpdates, 5 * 60 * 1000); // 5 minutes
      
      return () => clearInterval(interval);
    }
  }, []);

  const handleUpdate = () => {
    // Send message to service worker to skip waiting
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      });
    }
    
    // Reload the page to get the new version
    window.location.reload();
  };

  const handleDismiss = () => {
    setShowUpdate(false);
    setShowDialog(false);
  };

  return (
    <>
      {/* Snackbar notification */}
      <Snackbar
        open={showUpdate && !showDialog}
        onClose={handleDismiss}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={null}
      >
        <Alert 
          severity="info" 
          action={
            <Button 
              color="inherit" 
              size="small" 
              onClick={() => setShowDialog(true)}
              startIcon={<RefreshIcon />}
            >
              تحديث
            </Button>
          }
          onClose={handleDismiss}
        >
          إصدار جديد متاح من التطبيق
        </Alert>
      </Snackbar>

      {/* Dialog for update */}
      <Dialog 
        open={showDialog} 
        onClose={handleDismiss}
        dir="rtl"
        PaperProps={{
          sx: {
            borderRadius: 2,
            minWidth: 300
          }
        }}
      >
        <DialogTitle sx={{ textAlign: 'center', color: 'primary.main' }}>
          تحديث متاح
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
            تم إصدار نسخة جديدة من التطبيق تحتوي على تحسينات وميزات جديدة
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
            هل تريد تحديث التطبيق الآن؟
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', gap: 1 }}>
          <Button 
            onClick={handleDismiss} 
            variant="outlined"
            color="secondary"
          >
            لاحقاً
          </Button>
          <Button 
            onClick={handleUpdate} 
            variant="contained"
            startIcon={<RefreshIcon />}
            sx={{ minWidth: 120 }}
          >
            تحديث الآن
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdateNotification;
